const E = {
  ADD_LIQUIDITY: 1935855772,
  SWAP: 630424929,
  PROVIDE_LIQUIDITY: 4244235663,
  DIRECT_ADD_LIQUIDITY: 1291331587,
  REFUND: 200537159,
  RESET_GAS: 1117846339,
  COLLECT_FEES: 533429565,
  REQUEST_BURN: 1499400124
}, D = {
  v1: "v1"
};
export {
  E as DEX_OP_CODES,
  D as DEX_VERSION
};
//# sourceMappingURL=constants.js.map
